import type { AttachmentContent, UploadedFile } from 'app/types/attachment';
import AttachmentCard from 'core/modules/components/cards/AttachmentCard';
import { isImage } from 'core/utils/utils';
import { CONTENT_TYPES } from 'core/variables/constant';
import React from 'react';
import Button from '../../../../atoms/Button/Button';
import IconBubble from '../../../../molecules/IconBubble/IconBubble';
import MaterialPreviewMessages from './MaterialPreviewMessages';
import useMaterialPreviewStudentSidebar from './useMaterialPreviewStudentSidebar';

type Material = {
  icon?: string;
  typeName?: string;
  name?: string;
  course_messages_guid?: string;
  content_type_guid?: string;
};

type MaterialPreviewStudentSidebarProps = {
  material: Material;
  onClose: () => void;
  referenceMaterial?: AttachmentContent | null;
  attachedFiles?: UploadedFile[];
  contentLang?: string;
  courseGuid: string;
};

function MaterialPreviewStudentSidebar({
  material,
  onClose,
  referenceMaterial,
  attachedFiles = [],
  contentLang,
  courseGuid,
}: MaterialPreviewStudentSidebarProps): JSX.Element {
  const { t, hasAttachments, handleShowVisor } = useMaterialPreviewStudentSidebar({ referenceMaterial, attachedFiles });

  return (
    <div className="material-preview-student-sidebar">
      <div className="material-preview-student-sidebar__header">
        <div className="material-preview-student-sidebar__header-content">
          {material.icon && isImage(material.icon) ? (
            <div className="lesson-item-card__left-icon-img" style={{ backgroundImage: `url(${material.icon})` }} />
          ) : (
            <IconBubble name={material.icon} size="md" background="alpha" color="primary" />
          )}
          <div className="material-preview-student-sidebar__header-texts">
            <span className="lesson-element-item__type">{material.typeName}</span>
            <span className="lesson-element-item__name" lang={contentLang}>
              {material.name}
            </span>
          </div>
        </div>
        <Button ariaLabel={t('actions:Close')} variant="primary" leftIcon="close" onClick={onClose} />
      </div>

      {hasAttachments && (
        <div className="material-preview-student-sidebar__attachments">
          <AttachmentCard
            content={referenceMaterial}
            guid={referenceMaterial?.guid}
            title={referenceMaterial?.name}
            type={referenceMaterial?.content_type_guid}
            onDelete={null}
            onAddContent={null}
            headerInfo={t(material?.content_type_guid === CONTENT_TYPES.TEST ? 'common:Material adjunto en el quiz' : 'common:Material adjunto en la tarea')}
            style="link"
            onShowVisor={referenceMaterial ? handleShowVisor : null}
            uploadedFiles={attachedFiles}
          />
        </div>
      )}

      {material?.course_messages_guid && <MaterialPreviewMessages courseGuid={courseGuid} courseMessageGuid={material.course_messages_guid} t={t} />}
    </div>
  );
}

export default MaterialPreviewStudentSidebar;
